import React from 'react';
import { Row, Modal, Button , FormGroup  } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { formatDateTime } from '../../../../shared/utils/date';
import moment from 'moment';
import queryString from 'query-string';
import { Component } from 'react';
import update from 'immutability-helper';

class StopsListModal  extends Component {

    constructor(props) {
         super(props);
         this.state = {
             search: {
                 runId: props.runId,
                 stopId: '',
                 selectedTimeZone: moment.tz.guess()
             },
             errors: {},
         };
     }

    prepareFormData = form => {

        return queryString.stringify(form);
    }

    render(){

    const selectTableRow = {
                 mode: "radio",
                 clickToSelect: true,
                 onSelect: (row, isSelect, rowIndex, e) => {
                       this.setState({
                                   search: update(this.state.search, {
                                       stopId: {$set :row.stopId},
                                   }),
                               });
                     }
                }

        const { stops , showModal, onCloseModal } = this.props;
        return <Modal show={showModal} bsSize="lg">
            <Modal.Header>
                <Modal.Title>Stop Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row style={{ margin: 'auto 0' }}>
                    <h4>Stops</h4>
                    <BootstrapTable data={stops} keyField={stops.stopNumber} selectRow={selectTableRow}>
                        <TableHeaderColumn dataField="stopId"  hidden>
                            ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="stopNumber" isKey width="50">
                            #
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="stopName">Stop Name</TableHeaderColumn>
                        <TableHeaderColumn dataField="stopCode" width="150">
                            Stop Code
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="stopPlantCode" width="150">
                            Plant Code
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="stopDockCode" width="150">
                            Dock Code
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="plannedArrival" dataFormat={formatDateTime} width="150">
                            Arrival
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="plannedDeparture" dataFormat={formatDateTime} width="150">
                            Departure
                        </TableHeaderColumn>
                    </BootstrapTable>
                </Row>
                <div style={{ textAlign: 'right', marginTop: 20 }}>
                    <FormGroup controlId="submit">
                        <Button
                            bsStyle={'primary'}
                            onClick={onCloseModal}
                            href={`api/download-load-unload-sheet/UNLOADING_SHEET_${moment().format(
                                    'DD_MM_YYYY-H_mm'
                                  )}?${this.prepareFormData(this.state.search)}`}
                        >
                            Download U/L Sheet
                        </Button>
                    </FormGroup>
                </div>
                <div style={{ textAlign: 'right', marginTop: 20 }}>
                    <Button style={{ marginRight: 20 }} bsStyle="default" onClick={onCloseModal}>
                        Close
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    }
}

export default StopsListModal;
